'use strict';

var React = require('react');

var SvgMeasurementWeightIcon = function SvgMeasurementWeightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 3.75a.75.75 0 0 0-1.5 0c0 .966.784 1.75 1.75 1.75h4.25v1.5h-3.5a2.25 2.25 0 0 0-2.25 2.25v5a2.25 2.25 0 0 0 2.25 2.25h8.5a2.25 2.25 0 0 0 2.25-2.25v-5a2.25 2.25 0 0 0-2.25-2.25h-3.5v-1.5h4.25a1.75 1.75 0 0 0 1.75-1.75.75.75 0 0 0-1.5 0 .25.25 0 0 1-.25.25h-10a.25.25 0 0 1-.25-.25Zm.25 5.5a.75.75 0 0 1 .75-.75h4.25a3 3 0 1 0 0 6 3 3 0 0 0 0-6h4.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75v-5Zm5 3.75a1.5 1.5 0 0 0 1.478-1.756l-.998.832a.75.75 0 1 1-.96-1.152l.998-.832a1.5 1.5 0 1 0-.518 2.908Z"
  }));
};
SvgMeasurementWeightIcon.displayName = "MeasurementWeightIcon";

exports.SvgMeasurementWeightIcon = SvgMeasurementWeightIcon;
